import { React, useState, useContext, useEffect } from "react";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { AuthContext } from "../context/AuthContext"; // Adjust path
import { useSwipeable } from "react-swipeable";
import GamePageLayout from "./GamePageLayout"; // Adjust path
import styles from '../assets/css/CopyPaste.module.css'; // Import CSS Module
import { FaSquareWhatsapp } from "react-icons/fa6"; // WhatsApp Icon
import { MdDelete, MdClose } from "react-icons/md"; // Delete & Close Icons

function CopyPaste() {
  const { id } = useParams(); // Game ID
  const [values, setValues] = useState([]); // Holds pairs [number, amount]
  const [DigitInput, setDigitInput] = useState(""); // Manual digit input
  const [DigitInputWhastapp, setDigitInputWhastapp] = useState(""); // WhatsApp paste input
  const [AmountInput, setAmountInput] = useState(""); // Manual amount input
  const [Repetition, setRepetition] = useState(1); // 1 = No Palti, 0 = With Palti
  const [WhatsappDetail, setWhatsappDetail] = useState(false); // Toggle WhatsApp input modal
  const { isAuthenticated, Addbet, Gameinfo } = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(false); // Loading state for submit
  const navigate = useNavigate();
  // const [new_message, setnew_message] = useState(""); // Replaced by toast
  const [GameName, setGameName] = useState("Loading..."); // Game Name state

  // Redirect if not authenticated
  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/login");
    }
  }, [isAuthenticated, navigate]);

  // Fetch Game Info
  useEffect(() => {
    let isMounted = true;
    if (Gameinfo && id) {
        Gameinfo(id, (res) => {
            if (!isMounted) return;
            if (res.status === 0) {
                message(0, res.msg || "Failed to load game info");
                setGameName("Unknown Game");
            } else if (res.data && res.data.length > 0) {
                setGameName(res.data[0].game_name || "Unknown Game");
            } else {
                 setGameName("Unknown Game");
            }
        });
    } else {
        setGameName("Unknown Game");
    }
     return () => { isMounted = false; };
  }, [id, Gameinfo]);

  // Prevent back navigation (optional)
  useEffect(() => {
    window.history.pushState(null, "", window.location.href);
    const handlePopState = (event) => {
        navigate("/dashboard", { replace: true });
    };
    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, [navigate]);

  // Toast message function
  const message = (status, text) => {
    const options = {
        position: "top-right", autoClose: 3000, hideProgressBar: false,
        closeOnClick: true, pauseOnHover: true, draggable: true,
        progress: undefined, theme: "dark",
    };
    if (status === 1) toast.success(text, options);
    else if (status === 0) toast.error(text, options);
    else if (status === 2) toast.warning(text, options);
  };

  // Calculate total bet amount
  const calculateSum = () => {
    return values.reduce((sum, row) => {
      const amount = parseFloat(row[1]); // Amount is at index 1
      return sum + (isNaN(amount) ? 0 : amount);
    }, 0);
  };

  // Generate pairs from manual input
  const generateManualArray = (digitInput, amountInput, repetition) => {
    const digitString = String(digitInput).replace(/[^0-9]/g, '');
    const amount = parseFloat(amountInput);

    if (isNaN(amount) || amount <= 0) {
        return [0, [], "Please enter a valid amount."];
    }
    if (digitString.length % 2 !== 0) {
      return [0, [], "Digits must be entered in pairs (even length)."];
    }

    const resultArray = [];
    for (let i = 0; i < digitString.length; i += 2) {
      const pair = digitString.substring(i, i + 2);
      const numPair = parseInt(pair, 10);

      // Add the pair itself
      resultArray.push([numPair, amount]);

      // Add the reversed pair if "With Palti" (Repetition === 0) and digits are different
      if (repetition === 0 && pair[0] !== pair[1]) {
        const reversedPair = pair[1] + pair[0];
        const numReversedPair = parseInt(reversedPair, 10);
        // Avoid adding duplicates if already present (e.g., user typed 1221)
        if (!resultArray.some(item => item[0] === numReversedPair && item[1] === amount)) {
             resultArray.push([numReversedPair, amount]);
        }
      }
    }
    // Remove potential duplicate pairs generated by logic/palti
    const uniqueResultArray = Array.from(new Map(resultArray.map(item => [item[0], item])).values());

    return [1, uniqueResultArray, "success"];
  };

  // Parse WhatsApp message
  const parseWhatsappMessage = (msg) => {
    let parsedBets = [];
    // Basic cleaning (remove timestamps, sender names etc.) - Needs refinement
    let cleanedMsg = msg.trim();
    cleanedMsg = cleanedMsg.replace(/\[.*?\]\s*.*?:/g, ''); // Remove [time] Name: pattern
    cleanedMsg = cleanedMsg.replace(/<.*?\]\s*.*?:/g, ''); // Remove <time> Name: pattern
    cleanedMsg = cleanedMsg.replace(/^\s*[\*-]?\s*/gm, ''); // Remove leading bullets/spaces

    // Split into lines
    const lines = cleanedMsg.split('\n');

    lines.forEach(line => {
        // Try to match patterns like "Number x Amount" or "Number = Amount" or "Number - Amount" etc.
        // This regex is basic and might need significant improvement based on actual formats
        const match = line.match(/^(\d{1,2})\s*[-=xX*]\s*(\d+)/); // Matches "DD - Amount" or "DD = Amount" etc.
        if (match && match[1] && match[2]) {
            const number = parseInt(match[1], 10);
            const amount = parseInt(match[2], 10);
            if (!isNaN(number) && number >= 0 && number <= 99 && !isNaN(amount) && amount > 0) {
                parsedBets.push([number, amount]);
            }
        }
        // Add more regex patterns here to handle other formats if needed
    });

     // Remove duplicates based on the number
     const uniqueBets = Array.from(new Map(parsedBets.map(item => [item[0], item])).values());
    return uniqueBets;
  };


  // Handle Add Bet button (Manual Input)
  const handleManualAddBet = () => {
    if (DigitInput === "") {
      message(0, "Please enter digits."); return;
    }
    if (AmountInput === "" || parseFloat(AmountInput) <= 0) {
      message(0, "Please enter a valid amount."); return;
    }

    const [status, generatedValues, msg] = generateManualArray(DigitInput, AmountInput, Repetition);
    if (status === 0) {
      message(0, msg);
      // setValues([]); // Don't clear on manual add error, let user correct
    } else {
      // Append new bets, removing duplicates based on number
       const currentBetsMap = new Map(values.map(item => [item[0], item]));
       generatedValues.forEach(item => currentBetsMap.set(item[0], item));
       setValues(Array.from(currentBetsMap.values()));
      // Clear inputs after successful add
      setDigitInput("");
      setAmountInput("");
    }
  };

  // Handle Add from WhatsApp
  const handleWhatsappAdd = () => {
    if (DigitInputWhastapp === "") {
      message(0, "Please paste the WhatsApp message."); return;
    }
    const parsedValues = parseWhatsappMessage(DigitInputWhastapp);
    if (parsedValues.length === 0) {
        message(0, "Could not find valid bets in the message. Format should be like 'Number x Amount' per line.");
        return;
    }

    // Append new bets, removing duplicates based on number
    const currentBetsMap = new Map(values.map(item => [item[0], item]));
    parsedValues.forEach(item => currentBetsMap.set(item[0], item));
    setValues(Array.from(currentBetsMap.values()));

    setWhatsappDetail(false); // Close modal
    setDigitInputWhastapp(""); // Clear textarea
  };

  // Handle deleting a specific bet pair
  const handleDelete = (indexToDelete) => {
    setValues(currentValues => currentValues.filter((_, index) => index !== indexToDelete));
  };

  // Render table rows
  const renderRows = () => {
    return values.map((element, index) => (
      <tr key={index} className={styles.tableRow}>
        <td className={styles.tableCell}>{String(element[0]).padStart(2, '0')}</td>
        <td className={styles.tableCell}>{element[1]}</td>
        <td className={styles.tableCell}>
          <button onClick={() => handleDelete(index)} className={styles.deleteButton}>
            <MdDelete />
          </button>
        </td>
      </tr>
    ));
  };

  // Handle final bet submission
  const handleBettingSubmit = () => {
    if (isLoading) return;
    if (values.length === 0) {
      message(0, "No bets added to submit."); return;
    }
    setTimeout(() => {
      
    
    setIsLoading(true);

    const transformedValues = values.map((value) => ({
      bet_numbers: String(value[0]).padStart(2, '0'), // Number is at index 0
      bet_money: value[1], // Amount is at index 1
      type: 1, // Assuming CopyPaste generates Jodi (type 1)
    }));

    let grandTotal = calculateSum();

    if (Addbet) {
        Addbet(id, 1, JSON.stringify(transformedValues), grandTotal, (res) => {
            setIsLoading(false);
            if (res.status === 0) {
                message(0, res.msg || "Failed to place bet.");
            } else {
                message(1, res.msg || "Bet placed successfully!");
                 // Prepare receipt data
                 const today = new Date();
                 const day = String(today.getDate()).padStart(2, '0');
                 const month = String(today.getMonth() + 1).padStart(2, '0');
                 const year = today.getFullYear();
                 const formattedDate = `${day}-${month}-${year}`;
                 const receiptData = [
                     GameName,
                     formattedDate,
                     transformedValues, // Send structured bet data
                     grandTotal,
                     'Copy Paste' // Type for receipt
                 ];
                // Clear inputs and navigate
                setValues([]);
                setDigitInput("");
                setAmountInput("");
                setTimeout(() => {
                    navigate('/receipt', { state: { receiptData } });
                }, 500);
            }
        });
    } else {
        setIsLoading(false);
        message(0, "Betting function not available.");
    }
  }, 1000);
  };

  // Swipe handlers
  const handlers = useSwipeable({
    onSwipedRight: () => navigate(`/crossing/${id}`),
    // preventDefaultTouchmoveEvent: true,
    // trackMouse: true,
  });

  return (
    <>
      <GamePageLayout handlers={handlers} id={id} GameName={GameName} new_message={null}>
        {/* Game Type Tabs */}
        <div className={styles.gameList}>
          <Link to={`/play/${id}`} className={styles.gameLink}>
            JODI/HARUF
          </Link>
          <Link to={`/crossing/${id}`} className={styles.gameLink}>
            CROSSING
          </Link>
          <Link to={`/copypaste/${id}`} className={`${styles.gameLink} ${styles.activeGameLink}`}>
            COPY PASTE
          </Link>
        </div>

        {/* Input Area */}
        <div className={styles.inputArea}>
           <div className={styles.inputGroup}>
               <label htmlFor="digitInput" className={styles.inputLabel}>Enter Digits (In Pairs)</label>
               <input
                   id="digitInput"
                   type="tel"
                   inputMode="numeric"
                   className={styles.formInput}
                   value={DigitInput}
                   onInput={(e) => setDigitInput(e.target.value.replace(/[^0-9]/g, ''))}
                   placeholder="e.g., 123456"
               />
           </div>
           <div className={styles.inputGroup}>
               <label htmlFor="amountInput" className={styles.inputLabel}>Enter Amount (Per Bet)</label>
               <input
                   id="amountInput"
                   type="number"
                   inputMode="decimal"
                   className={styles.formInput}
                   value={AmountInput}
                   onInput={(e) => setAmountInput(e.target.value.replace(/[^0-9]/g, ''))}
                   placeholder="e.g., 10"
               />
           </div>

           {/* Palti Option & WhatsApp Paste */}
           <div className={styles.optionsContainer}>
                <div className={styles.paltiOption}>
                    <input
                        type="checkbox"
                        id="withPalti"
                        className={styles.paltiCheckbox}
                        checked={Repetition === 0} // 0 means With Palti
                        onChange={(e) => setRepetition(e.target.checked ? 0 : 1)}
                    />
                    <label htmlFor="withPalti" className={styles.paltiLabel}>With Palti</label>
                </div>
                <button className={styles.whatsappPasteButton} onClick={() => setWhatsappDetail(true)}>
                    <FaSquareWhatsapp /> Paste WhatsApp
                </button>
           </div>

           {/* Add Bet Button */}
           <div className={styles.buttonContainer}>
               <button onClick={handleManualAddBet} className={styles.addButton}>
                   Add Bet
               </button>
           </div>
        </div>

        {/* WhatsApp Paste Modal */}
        {WhatsappDetail && (
            <div className={styles.whatsappModalOverlay}>
                <div className={styles.whatsappModal}>
                    <button className={styles.closeModalButton} onClick={() => setWhatsappDetail(false)}>
                        <MdClose />
                    </button>
                    <h4 className={styles.modalTitle}>Paste WhatsApp Bets</h4>
                    <textarea
                        className={styles.whatsappTextarea}
                        value={DigitInputWhastapp}
                        placeholder="Paste your WhatsApp message here (e.g., 12 x 10, 34 = 20...)"
                        onChange={(e) => setDigitInputWhastapp(e.target.value)}
                    ></textarea>
                    <div className={styles.modalButtonContainer}>
                        <button onClick={handleWhatsappAdd} className={styles.modalAddButton}>
                            Add from WhatsApp
                        </button>
                    </div>
                </div>
            </div>
        )}


        {/* Bet Preview Table */}
        {values.length > 0 && (
          <div className={styles.previewArea}>
            <h3 className={styles.previewTitle}>Preview Bets ({values.length} Bets)</h3>
            <div className={styles.tableContainer}>
                <table className={styles.previewTable}>
                    <thead>
                        <tr>
                            <th>Number</th>
                            <th>Amount</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>{renderRows()}</tbody>
                </table>
            </div>
          </div>
        )}

        {/* Summary and Play Button */}
        {values.length > 0 && (
            <div className={styles.summaryContainer}>
              <span className={styles.totalAmount}>
                Total: ₹{calculateSum()}
              </span>
              <button
                className={styles.playButton}
                onClick={handleBettingSubmit}
                disabled={isLoading}
              >
                {isLoading ? 'Processing...' : 'PLAY'}
              </button>
            </div>
        )}
      </GamePageLayout>
    </>
  );
}

export default CopyPaste;
